module.exports = __webpack_public_path__ + "media/toolkits/COVIDicon-1-9ee525b5.svg";